import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import InterviewSlotsPage from "@/pages/admin/InterviewSlotsPage";

export const Route = createFileRoute("/_admin/admin/interview-slots")({
  head: () => pageHead("Admin · Interview Slots", "AKIVA admin · interview slots portal.", "/admin/interview-slots", true),
  component: InterviewSlotsPage,
});
